export LOGIN_IMAGE from './login.jpg';
export NCI_GDC_DNA from './NCI_GDC_DNA.png';
export GDC_LOGO from './gdc_logo.png';
export SUBMIT_ICON from './icon_gdc-submit.png';
